import ArrCheckbox from '../../../../common/arr-checkbox/ArrCheckbox';
import './columnCheckboxCell.scss';

const renderCheckboxCell = (
  params: any,
  columnKey: string,
  onCheckboxClick: (row: any, checked: boolean, columnKey: string) => void,
  isChecked: boolean
) => {
  const value = Number(params?.value ?? params?.row?.[columnKey] ?? 0);
  if (!(value > 0))
    return <span data-testid={`column-span`}>{params?.value ?? 0}</span>;

  const handleChange = (arg1?: any, arg2?: any) => {
    let nextChecked: boolean;

    if (typeof arg1 === 'boolean') {
      nextChecked = arg1;
    } else if (typeof arg2 === 'boolean') {
      nextChecked = arg2;
    } else if (
      arg1 &&
      typeof arg1 === 'object' &&
      'target' in arg1 &&
      typeof (arg1 as any).target?.checked === 'boolean'
    ) {
      nextChecked = (arg1 as React.ChangeEvent<HTMLInputElement>).target
        .checked;
    } else {
      nextChecked = !isChecked;
    }

    onCheckboxClick(params.row, nextChecked, columnKey);
  };

  return (
    <div
      className="checkbox-cell-wrapper"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      data-testid={`column-div-${params?.id ?? params.value}`}
    >
      <ArrCheckbox
        size="xs"
        checked={isChecked}
        onChange={handleChange}
        aria-label={`select-checkbox-${columnKey}-${params.id}`}
      />
      <span data-testid={`column-span-text-${columnKey}-${params.id}`}>
        {params.value}
      </span>
    </div>
  );
};

export const getColumns = (
  onCheckboxClick: (row: any, checked: boolean, columnKey: string) => void,

  selectedRowIdsRef: React.MutableRefObject<Set<string>>,
  selectedColumnsRef: React.MutableRefObject<Set<string>>
) => {
  const storedVisibleColumns: string[] = JSON.parse(
    localStorage.getItem('VisibleColumns') || '[]'
  );
  const allColumns = [
    {
      field: 'SearchName',
      headerName: 'Search Name',
      flex: 1,
      minWidth: 200,
      index: 0,
    },
    {
      field: 'searchNumber',
      headerName: 'Search Number',
      minWidth: 200,
      index: 1,
    },
    {
      field: 'SearchPath',
      headerName: 'Search Group',
      flex: 1,
      minWidth: 200,
      index: 2,
    },
    {
      field: 'Content',
      headerName: 'Content & Metadata',
      flex: 1,
      minWidth: 200,
      index: 3,
    },
    {
      field: 'workProduct',
      headerName: 'Work Product',
      flex: 1,
      minWidth: 200,
      index: 4,
    },
    {
      field: 'pureHits',
      headerName: 'Hits',
      minWidth: 200,
      renderCell: (params: any) => {
        const key = `${params.row.searchNumber}|pureHits`;
        const isChecked =
          selectedRowIdsRef.current.has(key) ||
          selectedColumnsRef.current.has('pureHits');
        return renderCheckboxCell(
          params,
          'pureHits',
          onCheckboxClick,
          isChecked
        );
      },
      index: 6,
    },
    {
      field: 'families',
      headerName: 'Family Members',
      minWidth: 200,
      isVisible: true,
      renderCell: (params: any) => {
        const key = `${params.row.searchNumber}|families`;
        const isChecked =
          selectedRowIdsRef.current.has(key) ||
          selectedColumnsRef.current.has('families');
        return renderCheckboxCell(
          params,
          'families',
          onCheckboxClick,
          isChecked
        );
      },
      index: 7,
    },
    {
      field: 'emailThreads',
      headerName: 'Email Threaded Docs',
      minWidth: 200,
      isVisible: true,
      renderCell: (params: any) => {
        const key = `${params.row.searchNumber}|emailThreads`;
        const isChecked =
          selectedRowIdsRef.current.has(key) ||
          selectedColumnsRef.current.has('emailThreads');
        return renderCheckboxCell(
          params,
          'emailThreads',
          onCheckboxClick,
          isChecked
        );
      },
      index: 8,
    },
    {
      field: 'nearDupes',
      headerName: 'Near Dupes',
      minWidth: 200,
      isVisible: true,
      renderCell: (params: any) => {
        const key = `${params.row.searchNumber}|nearDupes`;
        const isChecked =
          selectedRowIdsRef.current.has(key) ||
          selectedColumnsRef.current.has('nearDupes');
        return renderCheckboxCell(
          params,
          'nearDupes',
          onCheckboxClick,
          isChecked
        );
      },
      index: 9,
    },
    {
      field: 'uniqueHits',
      headerName: 'Unique Hits',
      minWidth: 200,
      isVisible: true,
      renderCell: (params: any) => {
        const key = `${params.row.searchNumber}|uniqueHits`;
        const isChecked =
          selectedRowIdsRef.current.has(key) ||
          selectedColumnsRef.current.has('uniqueHits');
        return renderCheckboxCell(
          params,
          'uniqueHits',
          onCheckboxClick,
          isChecked
        );
      },
      index: 11,
    },
    {
      field: 'inCombinedResults',
      headerName: 'Families Included in Combined Results',
      minWidth: 300,
      isVisible: true,
      index: 13,
    },
    {
      field: 'docsInCombinedResults',
      headerName: 'Email Threaded Docs Included in Combined Results',
      minWidth: 390,
      isVisible: true,
      index: 14,
    },
    {
      field: 'nearDupesCombinedResults',
      headerName: 'Near Dupes Included in Combined Results',
      minWidth: 350,
      isVisible: true,
      index: 15,
    },
  ];

  if (storedVisibleColumns.length === 0) {
    return allColumns.map((col) => ({...col, isVisible: true}));
  }
  const columnsWithVisibility = allColumns.map((col) => ({
    ...col,
    isVisible: !storedVisibleColumns.includes(col.field),
  }));
  return columnsWithVisibility;
};
